import { AppThunk } from '../../types';
import {
  setPayoffRequestsAction,
  setPayoffRequestsErrorAction,
  setPayoffRequestsFetchStatusAction,
  setCreatePayoffRequestsErrorAction,
  setCreatePayoffRequestsFetchStatusAction,
  setCancelPayoffRequestsErrorAction,
  setCancelPayoffRequestsFetchStatusAction,
} from './reducer';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { IPayoffRequestData } from '../../../types/order/title/IPayoffRequest';
import { cancelPayoffAsync, createPayoffAsync, getPayoffHistoryAsync } from '../../../API/order/title/adminPayoffAPI';

export const getPayoffRequest =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setPayoffRequestsErrorAction(null));
      dispatch(setPayoffRequestsFetchStatusAction(createFetchInProgress()));
      const response: IPayoffRequestData[] = await getPayoffHistoryAsync(orderId);
      dispatch(setPayoffRequestsAction({ orderId, value: response }));
      dispatch(setPayoffRequestsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setPayoffRequestsFetchStatusAction(createFetchedWithError()));
      dispatch(setPayoffRequestsErrorAction(e.message));
    }
  };
export const createPayoff =
  (orderId: string): AppThunk =>
  async (dispatch, getState) => {
    const payoffs = getState().order.payoffRequests.payoffRequest;
    try {
      dispatch(setCreatePayoffRequestsErrorAction(null));
      dispatch(setCreatePayoffRequestsFetchStatusAction(createFetchInProgress()));
      const response: IPayoffRequestData = await createPayoffAsync(orderId);
      dispatch(setPayoffRequestsAction({ orderId, value: [...payoffs[orderId], response] }));
      dispatch(setCreatePayoffRequestsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setCreatePayoffRequestsFetchStatusAction(createFetchedWithError()));
      dispatch(setCreatePayoffRequestsErrorAction(e.message));
    }
  };

export const cancelPayoff =
  (orderId: string, payoffRequestId: string): AppThunk =>
  async (dispatch, getState) => {
    const payoffs = getState().order.payoffRequests.payoffRequest;
    try {
      dispatch(setCancelPayoffRequestsErrorAction(null));
      dispatch(setCancelPayoffRequestsFetchStatusAction(createFetchInProgress()));
      const response: IPayoffRequestData = await cancelPayoffAsync(orderId, payoffRequestId);
      const payoffIndex = payoffs[orderId].findIndex((payoff) => payoff.id === payoffRequestId);
      if (payoffIndex !== undefined) {
        const newPayoffs = payoffs[orderId].slice();
        newPayoffs[payoffIndex] = response;
        dispatch(setPayoffRequestsAction({ orderId, value: newPayoffs }));
      }
      dispatch(setCancelPayoffRequestsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setCancelPayoffRequestsFetchStatusAction(createFetchedWithError()));
      dispatch(setCancelPayoffRequestsErrorAction(e.message));
    }
  };
